import { useEffect } from 'react';
import { CastType } from 'modules/queryBuilder/types';
import { AnimationSlide } from '../types';
import { ConditionSingleValueSelectProps } from '../../types';

const SHORT_DURATION = 120;

export const useUnsetCastTypeOnNonEditMode = (
  animation: AnimationSlide | null,
  editMode: boolean,
  onChange: ConditionSingleValueSelectProps<CastType>['onChange'],
) => {
  useEffect(() => {
    if (animation === AnimationSlide.right && !editMode) {
      /**
       * When castType is set to null it rerenders the entire component before the slide animation is finished.
       * SetTimeout is used to set the castType to null AFTER the slide animation is finished
       */
      setTimeout(() => {
        onChange(null);
      }, SHORT_DURATION);
    }
  });
};
